import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OnboardingCompanyInformation } from '@interfaces/a-organizar/onboardingCompanyInformation';
import { VaultMaskCnpjPipe } from '@shared/pipes/vault-mask-cnpj.pipe';
import { SharedModule } from '@shared/shared.module';
import {
  buildCompanyInitials,
  formatCompanyLocation,
} from '@features/dashboard/document-analysis-company/helpers/company-identity';

@Component({
  selector: 'app-company-analysis-header',
  standalone: true,
  imports: [CommonModule, VaultMaskCnpjPipe, SharedModule],
  templateUrl: './company-analysis-header.component.html',
  styleUrls: ['./company-analysis-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAnalysisHeaderComponent {
  @Input() company: OnboardingCompanyInformation | null = null;
  @Input() hasExpandedStage = false;
  @Output() toggleAll = new EventEmitter<void>();

  get initials(): string {
    return buildCompanyInitials(this.company?.corporateName);
  }

  get location(): string {
    return formatCompanyLocation(this.company?.city, this.company?.state);
  }

  get toggleAllLabel(): string {
    return this.hasExpandedStage ? 'Recolher tudo' : 'Expandir tudo';
  }
}
